import queryString from "query-string";
import type { InvitationType } from "../../../analytics/events";

export const INVITE_HANDOFF_PATH = "/invite/averer";
const INVITATION_TYPES: readonly InvitationType[] = ["admin", "investor", "nominee"];
// Invitation links carry a signed JWT; anything else is not an invitation.
const JWT_SHAPE = /^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/;
const STATE_KEY = "avererInvite";

export interface Invite {
  type: InvitationType;
  token: string;
}

const toInvite = (type: unknown, token: unknown): Invite | null => {
  const knownType = INVITATION_TYPES.find((candidate) => candidate === type);
  return knownType && typeof token === "string" && JWT_SHAPE.test(token) ? { type: knownType, token } : null;
};

/**
 * Moves the invitation out of the address bar before the app renders, into this history entry's
 * state, which survives a reload. Analytics records the page address on every event.
 */
export const stashInviteFromAddress = (): void => {
  if (window.location.pathname.replace(/\/$/, "") !== INVITE_HANDOFF_PATH) {
    return;
  }
  const query = queryString.parse(window.location.search);
  const invite = toInvite(query.type, query.invitation_token);
  if (!invite) {
    return;
  }
  window.history.replaceState({ ...window.history.state, [STATE_KEY]: invite }, "", window.location.pathname);
};

export const readStashedInvite = (): Invite | null => {
  const stored = window.history.state?.[STATE_KEY];
  return toInvite(stored?.type, stored?.token);
};
